import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementCategoryTitleRules(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;
    const categoryType = payload.categoryType;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementCategoryTitleRules?categoryType=${categoryType}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementCategoryTitleRules", {
      categoryType: categoryType,
      categories: responseData.data,
    });
  },

  async postEngagementCategoryTitleRule(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementCategoryTitleRule`,
      "POST",
      null,
      payload
    );
  },
  async deleteEngagementCategoryTitleRule(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementCategoryTitleRule`,
      "POST",
      null,
      postData
    );
  },
};
